(ns machtfit.planned-commission
  (:require [clojure.string :as str]
            [machtfit.dashboard-widgets :as widgets]
            [machtfit.datetime :as datetime]
            [machtfit.human :as human]
            [re-frame.core :as rf]))

(defn ^:export load [js-data]
  (rf/dispatch-sync [::init (js->clj js-data :keywordize-keys true)]))

(defn- percent-invalid-msg [value]
  (if (and (some? value) (>= value 0) (<= value 100))
    ""
    (when (some? value)
      "Bei Prozentangaben bitte nur Werte zwischen 0 und 100 eingeben.")))

(defn- date-invalid-msg [value]
  (if (and (not-empty value) (not (human/past? (datetime/string->date value))))
    ""
    (when (not-empty value)
      "Bitte ein Datum in der Zukunft eingeben.")))

(defn- count-invalid-msg [value]
  (if (and (some? value) (>= value 1))
    ""
    (when (some? value)
      "Die Zahl der Buchungen muss mindestens 1 betragen.")))

(rf/reg-sub ::validation-results
  :<- [:get [:data]]

  (fn [{:keys [type
               timeplan-percent
               timeplan-date
               quantityplan-percent
               quantityplan-count]} _]
    (case type
      :none ""
      :timeplan (str/trim
                 (str (percent-invalid-msg timeplan-percent) " " (date-invalid-msg timeplan-date)))
      :quantityplan (str/trim
                     (str (percent-invalid-msg quantityplan-percent) " " (count-invalid-msg quantityplan-count)))
      nil)))

(rf/reg-sub ::data-complete?
  :<- [:get [:data]]

  (fn [{:keys [type
               timeplan-percent
               timeplan-date
               quantityplan-percent
               quantityplan-count]} _]
    (case type
      :none true
      :timeplan (and (some? timeplan-percent)
                     (not-empty timeplan-date))
      :quantityplan (and (some? quantityplan-percent)
                         (some? quantityplan-count))
      nil)))

(rf/reg-sub ::data-changed?
  :<- [:get [:data]]
  :<- [:get [:init-data]]

  (fn [[{:keys [type
                timeplan-percent
                timeplan-date
                quantityplan-percent
                quantityplan-count]} init-data] _]
    (cond
      (not= type (get init-data :type))
      true

      (= type :timeplan)
      (or
       (not= timeplan-percent (:timeplan-percent init-data))
       (not= timeplan-date (:timeplan-date init-data)))

      (= type :quantityplan)
      (or
       (not= quantityplan-percent (:quantityplan-percent init-data))
       (not= quantityplan-count (:quantityplan-count init-data))))))

(rf/reg-sub ::data-changed-and-valid?
  :<- [::data-changed?]
  :<- [::data-complete?]
  :<- [::validation-results]

  (fn [[changed? complete? results] _]
    (and changed? complete? (= results ""))))

(rf/reg-event-db ::init
  (fn [db [_ plan message]]
    (let [data (-> plan
                   :data
                   (update :type keyword))]
      (-> db
          (assoc :data data)
          (assoc :init-data data)
          (assoc :io (plan :io))
          (assoc :message message)))))

(rf/reg-event-db ::set-data
  (fn [db [_ key value]]
    (-> db
        (assoc-in [:data key] value)
        (assoc :message nil))))

(rf/reg-event-fx ::save-plan-success
  (fn [_ [_ {:keys [success plan]}]]
    (when success
      {:dispatch [::init plan "Provisionsplan wurde gespeichert."]})))

(rf/reg-event-db ::save-plan-error
  (fn [db _]
    (assoc db :message "Beim Speichern des Provisionsplans ist ein Fehler aufgetreten.")))

(rf/reg-event-fx ::save-plan
  (fn [{:keys [db]} _]
    {:db db
     :post {:url (get-in db [:io :save-url])
            :csrf-token (get-in db [:io :csrf-token])
            :data (clj->js (db :data))
            :on-success #(rf/dispatch [::save-plan-success %])
            :on-error #(rf/dispatch [::save-plan-error %])}}))

(defn- planned-commission []
  [:div
   [widgets/radio-options
    {:name "planned-commission"
     :current-value @(rf/subscribe [:get [:data :type]])
     :choices [[:none
                [:span "die beim Angebot eingestellte Provision verwenden."]]
               [:timeplan
                [:span
                 "gelten "
                 [widgets/inline-input
                  {:type widgets/type-percent-decimal-or-nil
                   :value @(rf/subscribe [:get [:data :timeplan-percent]])
                   :on-save #(rf/dispatch [::set-data :timeplan-percent %])}]
                 " % Provision bis zum "
                 [widgets/inline-date-input
                  {:value @(rf/subscribe [:get [:data :timeplan-date]])
                   :on-save #(rf/dispatch [::set-data :timeplan-date %])}]
                 " einschliesslich."]]
               [:quantityplan
                (let [plan-count @(rf/subscribe [:get [:data :quantityplan-count]])]
                  [:span
                   "gelten "
                   [widgets/inline-input
                    {:type widgets/type-percent-decimal-or-nil
                     :value @(rf/subscribe [:get [:data :quantityplan-percent]])
                     :on-save #(rf/dispatch [::set-data :quantityplan-percent %])}]
                   (str " % Provision für die nächste" (when (not= plan-count 1) "n") " ")
                   [widgets/inline-input
                    {:type widgets/type-positive-number-or-nil
                     :value plan-count
                     :on-save #(rf/dispatch [::set-data :quantityplan-count %])}]
                   (str " Buchung" (when (not= plan-count 1) "en") ".")])]]
     :on-select #(rf/dispatch [::set-data :type %])}]])

(defn- save-button []
  (when @(rf/subscribe [::data-changed-and-valid?])
    [:a.mf-btn.mf-btn--primary.mf-btn--sm.mt-3
     {:on-click #(rf/dispatch [::save-plan])}
     "Plan speichern"]))

(defn- message-line []
  (let [validation @(rf/subscribe [::validation-results])
        message @(rf/subscribe [:get [:message]])]
    [:div.mt-2.space-y-1
     (when (not-empty validation) [:p.text-sm.text-error-700 validation])
     (when (not-empty message) [:p.text-sm.text-gray-600 message])]))

(defn supplier-detail []
  [:div#planned-commission
   [planned-commission]
   [save-button]
   [message-line]])
